export default __webpack_public_path__ + "static/map-afa459de4291850bb553d05e870d64f7.png";